import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  caseDetailsCardContainer: {
    marginBottom: '2rem',
    border: `1px solid ${theme.vars.palette.divider}`,
    boxShadow: 'none',
    '&:last-child': {
      marginBottom: 0
    }
  },
  caseDetailsCardHeader: {
    borderBottom: `1px solid ${theme.vars.palette.divider}`,
    backgroundColor: theme.vars.palette.background.elevation0,
    padding: '.75rem 1.18rem .75rem 1rem'
  },
  caseDetailsCardContent: {
    overflowX: 'hidden',
    wordWrap: 'break-word',
    p: {
      marginTop: 0
    }
  }
}));

export default useStyles;
